<template>
    <div>
        <loader-component v-if="isSendingDataToServer"></loader-component>
        <loader-component v-if="showLoader"></loader-component>
        <div v-else>
            <!-- responsive-header -->
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar-component></navbar-component>
                </header>
                <!-- header -->
                <!----------------------------------------------------------------------------------------->
                <!-- main -->
                <main class="single-product default" v-if="productInfo != null">
                    <div class="container">

                        <breadcrumb-component :productInfo="productInfo"></breadcrumb-component>
                        <product-info :productInfo="productInfo"></product-info>
                        <div class="row">
                            <div class="container">
                                <div class="col-12 default no-padding">
                                    <div class="product-tabs default">
                                        <div class="box-tabs default">
                                            <ul class="nav" role="tablist">
                                                <li class="box-tabs-tab">
                                                    <a class="active" data-toggle="tab" title="توضیحات" href="#description" role="tab" aria-expanded="false">
                                                        <i class="now-ui-icons ui-2_settings-90"></i> توضیحات
                                                    </a>
                                                </li>
                                                <li class="box-tabs-tab">
                                                    <a title="مشخصات" data-toggle="tab" href="#specifications" role="tab" aria-expanded="false">
                                                        <i class="now-ui-icons shopping_cart-simple"></i> مشخصات
                                                    </a>
                                                </li>


                                                <li class="box-tabs-tab">
                                                    <a data-toggle="tab" title="ویدیو‌ها" href="#video" role="tab" aria-expanded="false">
                                                        <i class="now-ui-icons tech_tv"></i> ویدیو‌ها
                                                    </a>
                                                </li>

                                                <li class="box-tabs-tab" @click="isLoadReviews = true">
                                                    <a data-toggle="tab" title="نظرات کاربران" href="#comments" role="tab" aria-expanded="false">
                                                        <i class="now-ui-icons shopping_shop"></i> نظرات کاربران
                                                    </a>
                                                </li>
                                                <li class="box-tabs-tab" @click="isLoadQuestions = true">
                                                    <a data-toggle="tab" title="پرسش و پاسخ" href="#questions" role="tab" aria-expanded="false">
                                                        <i class="now-ui-icons ui-2_chat-round"></i> پرسش و پاسخ
                                                    </a>
                                                </li>

                                            </ul>
                                            <div class="card-body default">
                                                <!-- Tab panes -->
                                                <div class="tab-content">
                                                    <technical-specifications :productInfo="productInfo"></technical-specifications>
                                                    <videos-component :productInfo="productInfo"></videos-component>
                                                    <description-component :isLoadDescription="isLoadDescription"></description-component>
                                                    <reviews-component :isLoadReviews="isLoadReviews" :productInfo="productInfo"></reviews-component>
                                                    <questions-component :isLoadQuestions="isLoadQuestions" :productInfo="productInfo"></questions-component>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <similar-products :productInfo="productInfo"></similar-products>
                    </div>
                </main>
                <!-- main -->
                <!------------------------------------------------------------------------------------------>
                <footer-component></footer-component>
                <footer-fixnav-component></footer-fixnav-component>
            </div>
        </div>

    </div>
</template>


<script>
    import { initialSite } from "../../module/initialSite";
    import { httpPromise } from "../../module/httpUtility";
    import breadcrumb from "./breadcrumb.vue";
    import similarProducts from "./similarProducts.vue";
    import productInfo from "./productInfo.vue";
    import questionsComponent from "./questions.vue";
    import reviewsComponent from "./reviews.vue";
    import technicalSpecifications from "./technicalSpecifications.vue";
    import videosComponent from "./videos.vue";
    import descriptionComponent from "./description.vue";

    export default {
        data() {
            return {
                productInfo: null,
                showLoader: false,
                isSendingDataToServer: false,
                isLoadDescription: false,
                isLoadReviews: false,
                isLoadQuestions: false,
                firstItem: null,
            }
        },
        components: {
            'breadcrumb-component': breadcrumb,
            'similar-products': similarProducts,
            'product-info': productInfo,
            'questions-component': questionsComponent,
            'reviews-component': reviewsComponent,
            'technical-specifications': technicalSpecifications,
            'videos-component': videosComponent,
            'description-component': descriptionComponent
        },
        methods: {
            sendToServer() {
                window.scrollTo(0, 0);
                this.isSendingDataToServer = true;
                httpPromise(this, '/v1/ProductManagement/ProductInformation/Read', 'get', { ProductId: this.$route.params.productId },
                    response => {
                        this.productInfo = response.data.Value;  
                        this.isSendingDataToServer = false;
                        createPageTitle(response.data.Value.Name);
                        createMetaDescription(response.data.Value.MetaDescription);
                        createProductSchema(response.data.Value.Name, response.data.Value.ShortName, response.data.Value.PicPath, response.data.Value.BrandTitle, response.data.Value.FinalPrice);
                        $(function () {
                            $('meta[name="description"]').attr("content", response.data.Value.MetaDescription);
                            $('meta[name="keywords"]').attr("content", response.data.Value.KeyWordsMetaTag);
                           /* $('link[rel="canonical"]').attr("href", response.data.Value.CanonicalHref);*/
                            $('meta[property="og:description"]').attr("content", response.data.Value.MetaDescription);
                            $('meta[property="og:image"]').attr("content", response.data.Value.PicPath);
                            if (response.data.Value.MetaTitle != null) {
                                document.title = response.data.Value.MetaTitle;
                            }

                            $('meta[name="product_id"]').attr("content", response.data.Value.Id);
                            $('meta[name="product_name"]').attr("content", response.data.Value.Name);
                            $('meta[name="product_price"]').attr("content", response.data.Value.FinalPrice);
                            $('meta[name="product_old_price"]').attr("content", response.data.Value.Price);
                            $('meta[name="availability"]').attr("content", response.data.Value.IsAvailable ? 'instock' : 'outofstock');
                            $('meta[name="guarantee"]').attr("content", response.data.Value.GuaranteeDescription);
                            $('meta[name="robots"]').attr("content", 'index');
                        });
                        initialJs();
                    },
                    response => {
                        this.isSendingDataToServer = false;
                    }
                );
            },

        },
        beforeMount: function () {
            httpPromise(this, '/v1/ContentManagement/RedirectPages/Read', 'get', '',
                response => {
                    var params = this.$router.currentRoute.params;
                    this.redirectPages = response.data.Value.filter(x => x.UrlTypeId == 1);
                    if (params.productId > 0) {
                        var path = "/product/" + params.productId + "/" + params.productName;
                        for (var i = 0; i < this.redirectPages.length; i++) {
                            if (this.redirectPages[i].OldPath == path.trim()) {
                                window.location.href = this.redirectPages[i].NewPath;
                            }
                        }
                    }
                },
                response => {

                }
            );
            initialSite(this);
            this.sendToServer();
        },
        watch: {
            $route: function (from, to) {
                this.sendToServer();
            }
        },

    }
</script>

<style scoped>
    /*بررسی گردد*/
    .product-add .parent-btn a {
        color: #fff !important;
    }
    /*بررسی گردد*/
    .product-guaranteed::after, .product-guaranteed::before {
        content: none;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .box-tabs .card-body p {
            font-size: 13px;
        }

        .box-tabs-tab {
            width: 100% !important;
            border-bottom: 1px solid #ddd;
            text-align: center !important;
            font-weight: bold;
        }
    }
</style>